/* Auto-close desktop menus on mouseleave / outside click / Esc
   Works for both <details> (dropdown) and .mega-menu blocks.
*/
(function () {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  function closeAll() {
    // Close all <details>
    header.querySelectorAll('header-menu details[open]').forEach(d => d.removeAttribute('open'));
    // Close all mega panels
    header.querySelectorAll('.mega-menu__content.is-open').forEach(p => p.classList.remove('is-open'));
  }

  // Hover intent: close shortly after leaving the whole header area
  let leaveTimer = null;
  header.addEventListener('mouseleave', () => {
    if (!isDesktop()) return;
    leaveTimer = window.setTimeout(closeAll, 160);
  });
  header.addEventListener('mouseenter', () => {
    if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
  });

  // Outside click closes everything
  document.addEventListener('click', (e) => {
    if (!isDesktop()) return;
    if (!header.contains(e.target)) closeAll();
  });

  // Escape closes everything
  document.addEventListener('keydown', (e) => {
    if (!isDesktop()) return;
    if (e.key === 'Escape') closeAll();
  });

  // Mega menu open/close on hover (no <details> here)
  header.querySelectorAll('.mega-menu').forEach(menu => {
    const panel = menu.querySelector('.mega-menu__content');
    if (!panel) return;

    let hoverTimer = null;

    menu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      if (hoverTimer) clearTimeout(hoverTimer);
      panel.classList.add('is-open');
    });

    menu.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      hoverTimer = setTimeout(() => panel.classList.remove('is-open'), 120);
    });
  });
})();
